export const If = (props: { children: React.ReactNode; condition: boolean }) =>
  props.condition ? <>{props.children}</> : null
